<template>
    <div class="game-container">
        <router-view 
            v-if="!isLoading"
            :enigmas="enigmas" 
            :group="group"
            :equationFinal="equationFinal"
            :finalAttempts="finalAttempts"
            :lastSuggestions="lastSuggestions"></router-view>
            <Loader v-else></Loader>

    </div>
</template>
<script>
import firebase from '../firebase/firebase.js'
import game from '../helpers/game.js'
import middleware from '../middleware/middleware.js'
import Bus from '../main.js'
import {tagManager} from "../helpers/integrationManager"
import decodeApi from "../api/decode"
import Loader from "../components/Loaders/LoaderFull"

export default {
    props: {
        db : {

        }
    },
    components:{Loader},
    data(){
        return{
            view : '',
            enigmas : [],
            group : [],
            lastSuggestions : {},
            firstSnapshot : false,
            equationFinal : '',
            finalAttempts : '',
            createdAt : '',
            unsubscribe : '',
            playersLength : '',
            firstAcess : true,
            alreadyReloaded: localStorage.getItem("alreadyLoaded"),
            startedAt : '',
            newMessages : '',
            attemptsLength : '',
            isLoading: true
        }
    },
    // async destroyed(){
    //     this.$emit('endClock')
    // },
    async created(){
        if(Boolean(!this.alreadyReloaded)) {
            localStorage.setItem("alreadyLoaded", true)
            setTimeout(() => { location.reload(); }, 1000); //TODO: Please, fix this sh*t
        }

        const { teamGameId, group, userId } = await this.$store.getters.getSimple(['teamGameId', 'group', 'userId'])
        // const { teamGameId, groupId, group, userId } = undefined
        // console.log("TG ID gameContainer: ", teamGameId)
        const groupId = await localStorage.getItem("groupId")
        const db = this.db
        let self = this
        this.$store.subscribe((mutation, state) => { this.newMessages = state.persistence.newMessages })
        try {
            db.collection('groups').doc(groupId).onSnapshot(async snapshot => {
                const { players } = await snapshot.data()
                this.$store.dispatch('simpleSave', { group : players })
                if(this.firstAcess == true){
                    this.playersLength = players.length
                    this.firstAcess = false
                }
                if(players.length != this.playersLength) this.$store.dispatch('simpleSave', { group : players }) 
                let teamGame = await snapshot.data().teamGameId
                // console.log("teamGame snapshot: ", teamGame)
                let [selfScore] = players.filter(player => {
                    return player.id == userId
                })
                await this.moneyOut(players)
                if(teamGame != teamGameId){
                    // console.log("entrou no if teamGame != teamGameId")
                    this.firstSnapshot = false
                    await this.unsubscribe()
                    // console.log("group: ", group)
                    await this.getTeamGame(teamGame, db)
                    this.$store.dispatch('simpleSave', { teamGameId : teamGame })
                }
                this.$store.dispatch('simpleSave', { score : selfScore.score })
            })            
        } catch (error) {
            //TODO: make a error message showing up instead console.log error
            // console.error("error on socket onSnapshot: ", error)
            let { teamGameId, groupId, group, userId } = await this.$store.getters.getSimple(['teamGameId', 'groupId', 'group', 'userId'])
            let errorBody = { teamGameId, groupId, group, userId }
            errorBody.workspaceId = localStorage.getItem("workspaceId")
            errorBody.catchError = error
            errorBody.line = "81"
            errorBody.file = "GameContainer.vue"
            // console.log("errorBody: ", errorBody)
            if(Boolean(!this.alreadyReloaded)){
                localStorage.setItem("errorLogs", JSON.stringify(errorBody))
                localStorage.setItem("alreadyLoaded", true)
                const { data: res } = await decodeApi.post(`/logs`,errorBody)
                location.reload()
            }
           
        }
        await this.getTeamGame(teamGameId, db)
    },
    methods: {
        moneyOut(players){
            const moneyOut = players.some(player => { return player.score > 0 })
            if(!moneyOut){
                this.$store.dispatch('simpleSave', {
                    typeExtract : 'moneyout'
                })
                this.$router.push({ name : 'final-team', params : { typeFinish : 'moneyout' } })
            }
            return
        },
        createEnigmas(enigmasReq){
            let enigmas = [{
                "status" : 'enigma-open',
                "letter" : 'a',
                'newSuggestion' : false
            },
            {
                "status" : 'enigma-closed',
                "letter" : 'b',
                'newSuggestion' : true
            },
            {
                "status" : 'enigma-closed',
                "letter" : 'c',
                'newSuggestion' : true
            }]

            enigmas.forEach((enigma,index) => {
                enigma.enigma = enigmasReq[index].enigma
                enigma.id = enigmasReq[index].id
            })

            return enigmas
        },
        async getTeamGame(teamGameId, db){
            const {group} = await this.$store.getters.getSimple(['group'])
            let self = this
            this.unsubscribe = db.collection('teamGames').doc(teamGameId)
                .onSnapshot(async snapshot => {
                    let { enigmas, chatIds, equation, createdAt, startedAt, status, attempts, scoreTeam, id } = await snapshot.data()
                    // let objectRedirect = await middleware.objectRedirectGame(status)
                    await self.statusGame(status, attempts, selfPlayer, group)
                    // if(status !== 'in progress' && !Boolean(localStorage.getItem("alreadyFinishedTag"))){
                    //     const workspaceId = localStorage.getItem("workspaceId")
                    //     if(this.$store.getters.getWsWithTagManager.includes(workspaceId)){
                    //         console.log("Finalizou GameContainer")
                    //         const { data: player } = JSON.parse(localStorage.getItem("player"))
                    //         delete player.cpf
                    //         const tag = "Finalizou o Decode Game"
                    //         localStorage.setItem("alreadyFinishedTag", true)
                    //         await tagManager(tag ,workspaceId, player)
                    //     }   
                    // }
                    let selfPlayer = await game.selfPlayer(group)
                    const correctAttempt = await self.verifyAttempts(attempts, selfPlayer)
                    if(correctAttempt){
                        return
                    }
                    // self.$router.push(objectRedirect)
                    // cria sugestões
                    const { suggestionsGroup } = await self.createAttempt(attempts)
                    if(self.firstSnapshot == false){
                        if(!localStorage.getItem('startedAt')) self.$emit('initClock', startedAt)

                        self.attemptsLength = attempts.length
                        self.createdAt = createdAt
                        self.startedAt = startedAt
                        if(!localStorage.getItem('startedAt')){
                            Bus.$emit('initClockStart', startedAt)
                        }
                        // salvar enigmas
                        let objectEnigmas = self.createEnigmas(enigmas)
                        self.enigmas = objectEnigmas
                        // salvar grupo
                        self.group = group
                        // salvar equação final
                        self.equationFinal = enigmas[3].enigma
                        // salvar inicio do Game
                        const workspaceId = localStorage.getItem("workspaceId")
                        // if(this.$store.getters.getWsWithTagManager.includes(workspaceId) && this.firstAcess){
                        //     console.log("Entrou no if da Gupy")
                        //     const { data: player } = JSON.parse(localStorage.getItem("player"))
                        //     delete player.cpf
                        //     const tag = "Iniciou o Decode Game"
                        //     await tagManager(tag ,workspaceId, player)
                        // }
                        self.$store.dispatch('saveStartGame', createdAt)
                        self.firstSnapshot = true
                        self.$store.dispatch('simpleSave', {
                            enigmas : self.enigmas,
                            group : self.group,
                            equationFinal : self.equationFinal,
                            chatIds,
                            startedAt
                        })
                    }else{
                        if(suggestionsGroup){
                            if(attempts[attempts.length - 1] && attempts[attempts.length - 1].enigmaOrder != 'equation'){
                                self.verifySelfSuggestion(suggestionsGroup[suggestionsGroup.length - 1], selfPlayer, attempts.length)
                                suggestionsGroup[suggestionsGroup.length - 1].status = 'added'
                                let letter = suggestionsGroup[suggestionsGroup.length - 1].enigma
                                Bus.$emit(`newSuggestion-${letter}`)
                            }
                        }
                    }
                    // salvar lastSuggestions (esperar o end point de enviar mensagem estar pronto)
                    self.lastSuggestions = await game.lastSuggestions(suggestionsGroup)
                    // salvar tentativa final
                    let { final } = await this.createAttempt(attempts)
                    self.finalAttempts = final
                    this.$store.dispatch('simpleSave', {
                        selfPlayer,
                        lastSuggestionsGroup : self.lastSuggestions,
                        finalAttempts : final,
                        attempts
                    })
                })
        },
        createAttempt(attempts){
            const final = attempts.filter(attempt => {
                return attempt.enigmaOrder == 'equation'
            })
            const suggestionsGroup = attempts.filter(attempt => {
                return attempt.enigmaOrder != 'equation'
            })

            return {final,suggestionsGroup}
        },
        async verifyAttempts(attemps, selfPlayer){
            let correct = false
            let selfCorrect = attemps.some(attempt => {
                if(attempt.correct == true && attempt.enigmaOrder == 'equation'){
                    correct = true
                }
                return attempt.enigmaOrder == 'equation' && attempt.correct == true && attempt.userId == selfPlayer.id
            })
            if(correct){
                let hit = 'group-hit'
                if(selfCorrect){
                    hit = 'self-hit'
                }
                await firebase.destroyedApp()
                this.$store.dispatch('simpleSave', {
                    typeExtract : hit
                })
                this.$router.push({name : 'correct-alert'})
                return correct
            }
            
            return
        },
        async statusGame(statusGame, attempts, selfPlayer, group){
            if(statusGame == 'in progress') return this.isLoading = false
            // console.log("statusGame: ", statusGame)
            const workspaceId = localStorage.getItem("workspaceId")
            if(!localStorage.getItem("alreadyFinishedTag") && this.$store.getters.getWsWithTagManager.includes(workspaceId)){
                // console.log("Entrou no if da Gupy")
                localStorage.setItem("alreadyFinishedTag", true)
                const { data: player } = JSON.parse(localStorage.getItem("player"))
                delete player.cpf
                const tag = "Finalizou o Decode Game"
                await tagManager(tag ,workspaceId, player)
            }            
            
            if(statusGame == 'timeout'){
                this.$store.dispatch('simpleSave', {
                    typeExtract : 'timeout'
                })
                this.$router.push({name : 'final-team', params : { typeFinish : 'timeout'}})
                return
            }

            if(statusGame == 'hit'){
                let selfPlayer = await game.selfPlayer(group)
                await this.verifyAttempts(attempts, selfPlayer)
                return
            }
            if(statusGame == 'zero score'){
                this.$store.dispatch('simpleSave', {
                    typeExtract : 'moneyout'
                })
                this.$router.push({ name : 'final-team', params : { typeFinish : 'moneyout' } })
                return
            }
        },
        verifySelfSuggestion(lastSuggestions, selfPlayer, attemptLenght){
            let enigma = lastSuggestions.enigmaOrder == 'equation' ? 'final' : lastSuggestions.enigmaOrder
            // if(this.attemptsLength != attemptLenght){
            //     selfPlayer.id != lastSuggestions.userId ? this.$toaster.success(`Nova sugestão no enigma ${enigma}`) : ''
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
    .game-container{
        // background-color: #2f353a;
    }
    @media only screen and (min-width: 750px){
        .game-container{
            height: 100%;
        }    
    }
</style>
